import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Dialog } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import clsx from 'clsx';
import i18n from 'i18next';

import {
  AppCancelButton,
  AppSaveButton,
} from '../../designe/buttons/app-button/AppButton';
import { useStyles } from './ConfirmDialog.styles';

const ConfirmDialog = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    title,
    children,
    isLoading = false,
    confirmTitleKey = 'common.confirm',
    rejectTitleKey = 'common.cancel',
    paperMaxWidth,
  } = props;
  const { t } = useTranslation();
  const currentLng = i18n.language;
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const isCloseDisabled = isLoading;

  const handleClose = (event?, reason?: 'backdropClick' | 'escapeKeyDown') => {
    if (isCloseDisabled) return;
    onClose(event, reason);
  };

  const effectivePaperMax = paperMaxWidth ?? 600;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={isCloseDisabled}
      PaperProps={{
        sx: { maxWidth: effectivePaperMax, width: '100%' },
      }}>
      <div
        className={clsx(classes.confirmDialogWrapper)}
        style={{ maxWidth: effectivePaperMax }}>
        <div className={classes.confirmDialogHeader}>
          <div className={classes.confirmDialogTitle}>{title}</div>
          <Button onClick={handleClose} disabled={isCloseDisabled}>
            <CloseIcon />
          </Button>
        </div>
        <div className={classes.confirmDialogContent}>{children}</div>
        <div className={classes.confirmDialogFooter}>
          <AppCancelButton onClick={handleClose} disabled={isCloseDisabled}>
            {t(rejectTitleKey)}
          </AppCancelButton>
          <AppSaveButton onClick={onSubmit} loading={isLoading}>
            {t(confirmTitleKey)}
          </AppSaveButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
